import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { SubscriptionBannerTypeOptions } from './subscription-banner.types';

@Component({
  selector: 'rt-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionBannerComponent {
  @Input() public type: SubscriptionBannerTypeOptions;
  @Input() public iconName: IconName;
  @Input() public message: string;
  @Input() public linkUrl: any[];
  @Input() public linkText: null | string;
  @Input() public contactText?: string;

  @Input() public isDismissible: boolean;

  @Output() public linkClick = new EventEmitter<void>();
  @Output() public closeBanner = new EventEmitter<MouseEvent>();

  public onCloseClick(event: MouseEvent) {
    this.closeBanner.emit(event);
  }

  public get bannerMessage() {
    return this.message + (this.contactText ? ' ' + this.contactText : '');
  }
}
